import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";
import profilePic1 from "../../img/profile1.jpg";
import profilePic2 from "../../img/profile2.jpg";
import profilePic3 from "../../img/profile3.jpg";
import profilePic4 from "../../img/profile4.jpg";

const Testimonial = () => {
 
  


  const clients = [
    {
      img: profilePic1,
      name: 'PhD Khalid MEKOUAR',
      profession: "PDG ESISA",
      review:
        "ESISA Analytica est un laboratoire de recherche de pointe, incarnant l'excellence scientifique. Grâce à des équipements de haute technologie et une équipe de chercheurs de premier plan, nous sommes en mesure de réaliser des projets innovants dans divers domaines technologiques. ESISA Analytica est véritablement un moteur d'innovation pour les entreprises et les chercheurs.",
    },
    {
      img: profilePic2,
      name: 'PhD Abdelatif HAFID',
      profession: "Directeur du laboratoire de recherche & Chercheur en IA appliquée à la finance",
      review:
        "ESISA Analytica représente une opportunité unique pour toute organisation ou chercheur désireux de collaborer avec un laboratoire d'excellence. Nous mettons à disposition un environnement où la recherche appliquée rencontre l'innovation, propulsant ainsi nos projets vers des horizons inédits. C’est un honneur de faire partie de cette structure de renommée mondiale.",
    },
    {
      img: profilePic4,
      name: 'PhD Rogers-Yves PELETTRET',
      profession: "PDG ATLINE SERVICES - SYCOMORE",
      review:
        "Ce laboratoire offre des solutions de recherche innovantes dans un cadre professionnel rigoureux.",
    },
    {
      img: profilePic3,
      name: 'PhD Youssef MEKOUAR',
      profession: "Directeur adjoint du laboratoire de recherche & chercheur en IA appliquée à l'écologie",
      review:
        "ESISA Analytica est un laboratoire idéale pour l'avancement de la recherche en intelligence artificielle, notamment dans le domaine crucial de l'écologie. Nous utilisons des algorithmes de pointe pour aborder des enjeux environnementaux et contribuer à la préservation de notre planète grâce à des solutions innovantes.",
    },
    {
      img: "profilePic5",  // Ajoutez une image pour Houda
      name: 'PhD Houda EL ALAMI',
      profession: "Chercheuse en IA appliquée à l'écologie",
      review:
        "Au sein d'ESISA Analytica, nous explorons des applications de l'IA pour résoudre des problématiques écologiques complexes. Grâce à nos recherches, nous développons des modèles capables de prédire et d'optimiser des solutions pour la gestion durable des ressources naturelles, en collaboration avec des experts de différents domaines.",
    },
    {
      img: "profilePic6",  // Ajoutez une image pour Abdelatif El Ouissari
      name: 'PhD Abdelatif EL OUISSARI',
      profession: "Chercheur en IA appliquée à la médecine",
      review:
        "ESISA Analytica représente une avancée majeure dans l'utilisation de l'intelligence artificielle pour la médecine. Nous nous consacrons à développer des solutions IA capables d'améliorer la qualité des soins et de proposer des traitements plus précis et personnalisés pour les patients. Chaque projet est une opportunité de repousser les frontières de l'innovation en santé.",
    },
    {
      img: "profilePic7",  // Ajoutez une image pour Abdelatif HAFID
      name: 'PhD Mehdi Iraqui',
      profession: " Professeur en sciences de l'information & Chercheur en Informatique ",
      review:
        "La recherche en IA appliquée à la finance est un domaine où ESISA Analytica excelle. Nous utilisons des modèles avancés pour analyser et prédire les tendances financières, offrant ainsi des solutions précieuses aux institutions financières et aux entreprises. La collaboration avec ce laboratoire permet de repousser les limites de l'innovation financière.",
    },
  ];
  




  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading tacm" style={{width:"100%", textAlign:"center"}}>
        <span className="tacm">ESISA ANALYTICA </span>
        <span> Core Team Manager </span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div style={{textAlign:"center"}} className="testimonial">
                {/* <img style={{marginBottom:"1rem"}} src={client.img} alt="" /> */}
                <h1 className="tacm ecriture">{client.name}</h1>
                <h3 className="tacm ecriture2">{client.profession}</h3>
                <span className="tacm">{client.review}</span>
          

              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
